import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'
import { useTrackFinancialInsightsButtonClick } from '@/utils/sharedHooks'

import { Card, CardColors, Icon, Separator, Link, Text, Button } from '@/ui'
import {
  ARTICLE_TYPE,
  FinancialInsightsButtonType,
  INSIGHTS_TYPE,
  insightsCopyConstants,
} from './utils'
import { TypographyStyles, TextColors } from '@/styles'

const getArticleCardIcon = (type: string) => {
  if (type === ARTICLE_TYPE.WEBINAR) {
    return regular('video')
  }
  return regular('newspaper')
}

export const ArticleCard = ({
  title,
  type,
  url,
  insightsType,
}: {
  title: string
  type: ARTICLE_TYPE
  url: string
  insightsType: INSIGHTS_TYPE
}) => {
  const trackInsights = useTrackFinancialInsightsButtonClick()

  const goToUrl = () => {
    window.open(url, '_blank', 'noreferrer')

    trackInsights({
      button: FinancialInsightsButtonType.LEARN_MORE_CARD,
      insightsType,
    })
  }

  return (
    <Card color={CardColors.LEVEL_0} className="min-h-[140px]">
      <div className="w-full space-y-2">
        <div className="flex items-center">
          <Icon
            className="flex justify-center"
            icon={getArticleCardIcon(type)}
          />
          <Text
            className="flex-1 pl-3"
            variant={TypographyStyles.EYEBROW}
            color={TextColors.MUTED}
          >
            {type}
          </Text>
          <Button
            className="w-6 flex justify-end"
            iconLeft={regular('arrow-up-right-from-square')}
            variant="discreet"
            onClick={goToUrl}
          />
        </div>

        <Separator />

        <Link
          href={url}
          newPage
          className="pt-2 text-black"
          trackMessage={insightsCopyConstants[insightsType].trackButton}
          trackAttributes={{
            button: FinancialInsightsButtonType.LEARN_MORE_CARD,
          }}
        >
          {title}
        </Link>
      </div>
    </Card>
  )
}
